import { IHandleOtpSubmit } from '../../utils/types/Promoter';
import { getToken } from '../utils/token';
import { apiUms, apiHms } from './index';

export const generateOtp = (phoneNumber: string) => {
	return apiUms.post('/ums/profile/login', { phoneNumber });
};

export const verifyOtpforPromoter = (data: IHandleOtpSubmit) => {
	return apiUms.post('/ums/profile/verify', data);
};

export const fetchRetailerList = async (promoterId: string) => {
	const token = await getToken();
	return apiHms.get('/promoter/retailers', {
		headers: {
			token
		},
		params: {
			promoterId
		}
	});
};

export const getProfileData = (token: string) => {
	return apiHms.get('/user/profile', {
		headers: {
			token
		}
	});
};

export const createPromoterTransaction = async (
	promoterId: string | undefined,
	retailerId: string,
	catalogueQuantityMap: Record<string, number>,
	companyId: string,
	stockType: string
) => {
	const token = await getToken();
	return apiHms.post(
		'/promoter/transaction',
		{
			promoterId,
			retailerId,
			catalogueQuantityMap,
			companyId,
			stockType
		},
		{
			headers: {
				token
			}
		}
	);
};

export const listCatalogueData = async (companyId: string, searchTerm = '') => {
	const token = await getToken();
	return apiHms.get(`/user/catalogue/company/${companyId}?searchText=${searchTerm}`, {
		headers: {
			token
		}
	});
};

export const getAllPromoterTransaction = async (promoterId: string, page: number, record: number) => {
	const token = await getToken();
	return apiHms.get(`/promoter/transactions`, {
		headers: {
			token
		},
		params: {
			promoterId,
			page,
			record
		}
	});
};

export const getPromoterTransactionById = async (transactionId: string) => {
	const token = await getToken();
	return apiHms.get(`/promoter/transaction/${transactionId}`, {
		headers: {
			token
		}
	});
};
